import type { SlideChapterDefinition } from '@/components/SlideWizard'
import Slide1Title from './slides/Slide1Title'
import Slide2Bridge from './slides/Slide2Bridge'
import Slide3Secrecy from './slides/Slide3Secrecy'
import Slide4TooGood from './slides/Slide4TooGood'
import Slide5Payment from './slides/Slide5Payment'
import Slide6Strangers from './slides/Slide6Strangers'
import Slide7Access from './slides/Slide7Access'
import Slide8Practice from './slides/Slide8Practice'
import Slide9BeRude from './slides/Slide9BeRude'

export const warningSignsChapter: SlideChapterDefinition = {
  id: 'warning-signs',
  title: 'Spot the Warning Signs',
  description: 'Five scam signals you should never ignore.',
  estimatedMinutes: 5,
  slides: [
    { id: 'ws-title', component: Slide1Title, label: 'Introduction' },
    { id: 'ws-bridge', component: Slide2Bridge, label: 'From detection to recognition' },
    { id: 'ws-secrecy', component: Slide3Secrecy, label: 'Demands for secrecy' },
    { id: 'ws-too-good', component: Slide4TooGood, label: 'Too-good-to-be-true offers' },
    { id: 'ws-payment', component: Slide5Payment, label: 'Untraceable payments' },
    { id: 'ws-strangers', component: Slide6Strangers, label: 'Requests from strangers' },
    { id: 'ws-access', component: Slide7Access, label: 'Requests for access' },
    { id: 'ws-practice', component: Slide8Practice, label: 'Exercise: Spot the red flags', requiresInteraction: true },
    { id: 'ws-be-rude', component: Slide9BeRude, label: 'Pause and verify' },
  ],
}
